// visualizerOpacity.js
var VisualizerOpacity = pc.createScript('visualizerOpacity');


VisualizerOpacity.attributes.add('analyser', {
    type: 'entity'
});
VisualizerOpacity.attributes.add('freqcolor', {
    type: 'rgba'
});

VisualizerOpacity.attributes.add('timecolor', {
    type: 'rgba'
});

VisualizerOpacity.attributes.add('heightScale', {
    type: 'number',
    default: 1
});

// initialize code called once per entity
VisualizerOpacity.prototype.initialize = function() {
    console.info(this.analyser.script.analyser.maxDecibels);
    this.lines = [];
    var count = this.analyser.script.analyser.fftsize;
    for (var i = 0; i < count; i++) {
        this.lines.push(new pc.Vec3());
    }

    this.yScale = 1;
    this.xScale = 0.10 * 2048 / count;
    console.info(this.analyser);
    this.minDb = this.analyser.script.analyser.minDecibels;
    this.maxDb = this.analyser.script.analyser.maxDecibels;
    this.freqScale = 1 / (this.maxDb - this.minDb);
    this.freqOffset = this.minDb;
    this.opacMat = this.entity.model.model.meshInstances[0].material;
};

// update code called every frame
VisualizerOpacity.prototype.update = function(dt) {
    this.freqScale = 1 / (this.maxDb - this.minDb);
    this.freqOffset = this.minDb;
   // console.log(this.analyser.script.analyser.freqData[0]);
    //console.info(this.analyser.script.analyser.freqData[1] / -100);
    var scl = this.analyser.script.analyser.freqData[0] / -100;
    var iScl = this.entity.getLocalScale().x;
  
    this.opacMat.opacity = scl;
    this.opacMat.update();
    console.log('dings: ' + this.opacMat.opacity);
    
    //this.fadeElements[0].render.material.emissiveIntensity = this.analyser.script.analyser.freqData[64] / -100;
    //console.info(this.analyser.script.analyser.freqData);
    //this.fadeElements[0].render.material.update();



    // this.renderData(this.analyser.script.analyser.freqData, this.freqcolor, this.freqScale, this.freqOffset);
    // this.renderData(this.analyser.script.analyser.timeData, this.timecolor, 0.5, 0);
};


VisualizerOpacity.prototype.renderData = function (data, color, scale, offset) {
    // var line = 0;
    // for (var i = 0; i < data.length; i++) {
    //     if (line < this.lines.length) {
    //         var h1 = scale * (data[i] - offset);
    //         var h2 = scale * (data[i+1] - offset);

    //         this.lines[line].set(i * this.xScale, this.heightScale*h1, 0);
    //         this.lines[line+1].set((i+1) * this.xScale, this.heightScale*h2, 0);

    //         line += 2;
    //     }
    // }
    // this.app.renderLines(this.lines, color);
};

